// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__JK0vz","options":"Select_options__vL6xg","item":"Select_item__2xA7B"};